import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ContentWrapper, Panel } from '@checkmarx/cx-ui';
import { Scrollbars } from 'react-custom-scrollbars';
import TeamsTreeView from '../teamsTreeView';
import MembersGrid from '../membersGrid/index';
import AddTeam from '../addTeam';
import EllipsisTitle from '../../portal/ellipsisTitle';
import PortalToastrContainer from '../../portal/portalToastrContainer';
import ScreenLoaderContainer from '../../portal/controls/screenLoaderContainer';
import ErrorDialog from '../../portal/dialogs/errorDialog';
import ConfirmationDialog from '../../portal/dialogs/confirmationDialog';
import TeamsMainContainer from '../teamsMainContainer';
import Permissions from '../../../services/enums/permissions';
import { asArray } from '../../../services/utils';
import { isUserPermissionsInclude } from '../../../services/autorization';

@inject('translationsStore', 'teamsStore', 'usersStore', 'teamMembersStore',
    'rootLdapStore', 'ldapTeamMappingStore', 'oidcStore', 'configurationsStore') @observer
export default class Teams extends Component {

    state = {
        openErrorDialog: false,
        openDragTeamConfirmDialog: false,
        teamAName: '',
        teamBName: '',
        draggedTeamInfo: undefined,
        sortingFunction: (a,b) => a.title.localeCompare(b.title) // function to be passed on team tree (default A-Z)
    };
    
    currentUser = this.props.oidcStore.currentUser;
    arr = asArray(this.currentUser.profile['access-control-permissions']);
    p = isUserPermissionsInclude(this.arr);
    permit = this.p(Permissions.manageAuthenticationProviders);

    setTeamSortingFunction(func) {
        var stateCopy = {...this.state};
        stateCopy.sortingFunction = func;
        this.setState(stateCopy);
    }

    componentWillMount() {

        this.props.configurationsStore.setConfigurations().then(() => {
            if (this.permit && this.props.configurationsStore.isMultitenancyMode === false) {

                this.props.rootLdapStore.getLDAPServers()
                    .then(() => {

                        this.initSelectedTeamId();
                    });
            }
            else {

                this.initSelectedTeamId();
            }
        });

    }

    initSelectedTeamId = () => {

        this.props.teamsStore.getAllTeams().then((teams) => {

            if (teams && teams.length > 0) {

                const teamId = teams[0].id;

                this.props.teamsStore.setSelectedTeamId(teamId);
                this.props.teamsStore.setTeamIds([`${teamId}`]);
                this.props.teamMembersStore.getTeamUsers(teamId);
                this.getLdapTeamMapping(teamId);
            }
        });
        this.props.usersStore.getAllUsers();
    }

    onSelect = (selectedKeys, info) => {

        if (selectedKeys[0] !== undefined) {

            const inx = selectedKeys.length - 1;
            const teamId = selectedKeys[inx];
            this.props.teamsStore.resetTeamIds();
            this.props.teamsStore.setTeamIds([`${teamId}`]);
            this.props.teamsStore.setSelectedTeamId(teamId);
            this.props.teamMembersStore.getTeamUsers(teamId);
            this.getLdapTeamMapping(teamId);
        }
    }

    getLdapTeamMapping(selectedTeamId) {

        if (this.props.configurationsStore.isMultitenancyMode === false) {
            this.props.ldapTeamMappingStore.getByTeamId(selectedTeamId);
        }
    }

    closeDragTeamConfirmDialog = () => {

        this.setState({
            openDragTeamConfirmDialog: false
        });
    }

    onDrop = (info) => {

        const nameA = info.node.props.title;
        const nameB = info.dragNode.props.title;

        this.setState({
            openDragTeamConfirmDialog: true,
            draggedTeamInfo: info,
            teamAName: nameA,
            teamBName: nameB
        });
    }

    handleMovingError = () => {

        this.closeDragTeamConfirmDialog();
        this.openErrorDialog();
    }

    getAllTeamsAfterMove = () => {

        this.props.teamsStore.getAllTeams()
            .then(() => {

                this.closeDragTeamConfirmDialog();
            })
            .catch(() => {

                this.handleMovingError();
            })
            .finally(() => {

                this.props.teamsStore.updatingTeam = false;
            });
    }

    moveTeam = () => {

        const info = this.state.draggedTeamInfo;
        const dropKey = info.node.props.eventKey;
        const dragKey = info.dragNode.props.eventKey;
        const name = info.dragNode.props.title;

        this.props.teamsStore.updateTeam(dragKey, name, dropKey)
            .then(() => {

                this.props.teamsStore.updatingTeam = true;
                this.getAllTeamsAfterMove();
            })
            .catch(() => {

                this.handleMovingError();
            });
    }

    openErrorDialog = () => {

        this.setState({
            openErrorDialog: true
        });
    }

    closeErrorDialog = () => {

        this.setState({
            openErrorDialog: false
        });
    }


    render() {

        let grid, title, treeView, confirmTeamMoveText = undefined, teamsMainContainer, disableTeamMenu = true;

        const shouldLoadLDAPServers = this.permit && this.props.rootLdapStore.ldapServers === undefined && this.props.configurationsStore.isMultitenancyMode === false;

        if (this.props.teamMembersStore.teamUsers === undefined
            || this.props.teamsStore.teams === undefined
            || this.props.teamsStore.selectedTeamId === undefined
            || shouldLoadLDAPServers) {

            treeView = <ScreenLoaderContainer />;
            teamsMainContainer = <div style={{ height: '72vh' }}><ScreenLoaderContainer /></div>;
        } else {
            treeView = <Scrollbars style={{ height: '74vh' }}>
                <TeamsTreeView
                    teams={this.props.teamsStore.teams}
                    selectable={true}
                    selectedKeys={this.props.teamsStore.teamIds.map(String)}
                    onSelect={this.onSelect}
                    checkStrictly={true}
                    checkable={false}
                    draggable={true}
                    onDrop={this.onDrop}
                    onRightClick={this.props.onRightClick}
                    sortingFunction={this.state.sortingFunction}
                />
            </Scrollbars>;

            title = <EllipsisTitle width='70%' title={this.props.teamsStore.selectedTeamName} />;
            grid = <MembersGrid teamUsers={this.props.teamMembersStore.teamUsers} />;

            confirmTeamMoveText = this.props.translationsStore.translate('CONFIRM_MOVE_TEAM')
                .replace('{folderA}', this.state.teamBName)
                .replace('{folderB}', this.state.teamAName);

            teamsMainContainer = <TeamsMainContainer
                title={title}
                grid={grid}
                translationsStore={this.props.translationsStore}
            />;
            disableTeamMenu = false;
        }

        return (
            <div className='organization-wrapper' data-cy='teams-screen'>
                <ContentWrapper className='content-wrapper'>
                    <Panel className='content-left-hand'>
                        <div className='content-header'>
                            <AddTeam 
                              disableTeamMenu={disableTeamMenu} 
                              setSortFunction={this.setTeamSortingFunction.bind(this)} />
                        </div>
                        <div className='content-body'>
                            <div className='teams-treeview-wrapper'>
                                {treeView}
                            </div>
                        </div>
                    </Panel>
                    <Panel className='content-right-hand'>
                        {teamsMainContainer}
                    </Panel>
                </ContentWrapper>
                <PortalToastrContainer />
                <ConfirmationDialog
                    open={this.state.openDragTeamConfirmDialog}
                    onButtonClick={this.moveTeam}
                    onCancelClick={this.closeDragTeamConfirmDialog}
                    buttonText={this.props.translationsStore.translate('MOVE')}
                    titleText={this.props.translationsStore.translate('CONFIRM_MOVE_TEAM_TITLE')}
                    contentText={confirmTeamMoveText}
                    inProgress={this.props.teamsStore.updatingTeam}
                />
                <ErrorDialog
                    show={this.state.openErrorDialog}
                    onConfirm={this.closeErrorDialog}
                    deleteButtonText={this.props.translationsStore.translate('CLOSE')}
                    closeDeleteDialog={this.closeErrorDialog}
                    titleText={this.props.translationsStore.translate('ERROR')}
                    contentText={this.props.teamsStore.teamErrorMessage} />
            </div>
        );
    }
}
